import clsx from "clsx"
import styled from "styled-components"

interface CollapsibleProps {
  open: boolean
  children?: React.ReactNode
}

const CollapsibleWrapper = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: all 0.3s ease-in-out;

  & > div {
    transition: all 0.1s ease-in-out;
    overflow: hidden;
    padding-top: 0px;
  }

  &.open {
    grid-template-rows: 1fr;

    & > div {
      padding-top: 16px;
    }
  }
`

export const Collapsible: React.FC<CollapsibleProps> = ({ open, children }) => {
  return (
    <CollapsibleWrapper className={clsx({ open })}>
      <div>{children}</div>
    </CollapsibleWrapper>
  )
}
